import getList from './getList';
import add from './add';
// import edit from './edit';
import del from './del';
export default {
  getList,
  add,
  del,
  // edit,
};


// WEBPACK FOOTER //
// ./src/api/attaches/index.ts